// extracted by mini-css-extract-plugin
export default {"card":"Card_card__48SLx","withMarginTop":"Card_withMarginTop__PGWgf","withMarginBottom":"Card_withMarginBottom__v5cHv"};